'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCurrentReducer = exports.generateListReducer = exports.generateResponseDataReducer = exports.generateFetchStatusReducer = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _redux = require('redux');

var _fetchStatus = require('./fetchStatus');

var fetchStatus = _interopRequireWildcard(_fetchStatus);

var _actions = require('./actions');

var _index = require('../constants/index');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var generateFetchStatusReducer = exports.generateFetchStatusReducer = function generateFetchStatusReducer(_ref) {
  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? '' : _ref$namespace,
      _ref$resetActions = _ref.resetActions,
      resetActions = _ref$resetActions === undefined ? [] : _ref$resetActions;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetchStatus.initialState();
    var action = arguments[1];

    if ((0, _actions.composeActionName)([namespace, _index.REQUEST]) === action.type) {
      return fetchStatus.requestState();
    }

    if ((0, _actions.composeActionName)([namespace, _index.SUCCESS]) === action.type) {
      return fetchStatus.successState();
    }

    if ((0, _actions.composeActionName)([namespace, _index.FAILURE]) === action.type) {
      return fetchStatus.failureState();
    }

    if (resetActions && resetActions.includes(action.type)) {
      return fetchStatus.initialState();
    }

    return state;
  };
};

var generateResponseDataReducer = exports.generateResponseDataReducer = function generateResponseDataReducer(_ref2) {
  var _ref2$namespace = _ref2.namespace,
      namespace = _ref2$namespace === undefined ? '' : _ref2$namespace,
      _ref2$initialState = _ref2.initialState,
      initialState = _ref2$initialState === undefined ? {} : _ref2$initialState,
      _ref2$transformPayloa = _ref2.transformPayload,
      transformPayload = _ref2$transformPayloa === undefined ? function (payload) {
    return payload.data ? _extends({}, payload.data) : {};
  } : _ref2$transformPayloa;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if ((0, _actions.composeActionName)([namespace, _index.REQUEST]) === action.type) {
      return initialState;
    }

    if ((0, _actions.composeActionName)([namespace, _index.SUCCESS]) === action.type) {
      return transformPayload(action.payload);
    }

    if ((0, _actions.composeActionName)([namespace, _index.FAILURE]) === action.type) {
      return initialState;
    }

    return state;
  };
};

var generateListReducer = exports.generateListReducer = function generateListReducer(_ref3) {
  var _ref3$namespace = _ref3.namespace,
      namespace = _ref3$namespace === undefined ? '' : _ref3$namespace,
      initialState = _ref3.initialState,
      transformPayload = _ref3.transformPayload,
      resetActions = _ref3.resetActions;
  return (0, _redux.combineReducers)({
    fetchStatus: generateFetchStatusReducer({
      namespace: namespace,
      resetActions: resetActions
    }),
    data: generateResponseDataReducer({
      namespace: namespace,
      initialState: initialState,
      transformPayload: transformPayload
    }),
    meta: generateResponseDataReducer({
      namespace: namespace,
      initialState: {},
      transformPayload: function transformPayload(payload) {
        return payload.meta ? _extends({}, payload.meta) : {};
      }
    })
  });
};

var generateCurrentReducer = exports.generateCurrentReducer = function generateCurrentReducer(_ref4) {
  var _ref4$namespace = _ref4.namespace,
      namespace = _ref4$namespace === undefined ? '' : _ref4$namespace,
      initialState = _ref4.initialState,
      transformPayload = _ref4.transformPayload,
      resetActions = _ref4.resetActions;
  return (0, _redux.combineReducers)({
    fetchStatus: generateFetchStatusReducer({
      namespace: namespace,
      resetActions: resetActions
    }),
    data: generateResponseDataReducer({
      namespace: namespace,
      initialState: initialState,
      transformPayload: transformPayload
    })
  });
};